module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"check":"You have not given permission to access your camera or microphone.","p1":"Choose the menu tab \\"Safari\\" → \\"Preferences\\" and click \\"Websites\\";","p2":"Select first Camera and then Microphone and set \\"Allow\\" for huntica.ai;","p3":"Close the settings and reload the page.","more":"Learn more on the","support":"Apple Support site"}}')
  delete Component.options._Ctor
}
